import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */

/**
 * Responsive ToolBar
 * The idea to have two different section:  1 - horizontal toolbar
 * 2 - hidden button that has a menu of the actions
 * It would need to watch for children to be added so it can dynamic create
 * the action menu
 * 
 * 
 * see https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver to watch
 * the dom
 * 
 */
class Toolbar extends BaseComponent {
	
	static get properties() {
		return {			
			bodyStyle: {type: String},
			collapseLabel: {type: String, attribute: 'collapse-label'}
		};
	}
	
	constructor() {
		super();
		
		this.bodyStyle = '';
		this.collapseLabel = 'Actions';
		
		var toolbar = this;
		setTimeout(function(){
			toolbar.init();
		});		
	}
	
	render() {	
		return html`
			<style>
				.main-toolbar {
					display: block;
				}
		
				.action-button {
					display: none;
					width: 100%;
					--vaadin-button-background: var(--dl-toolbar-action-background, whitesmoke);
					--vaadin-button-text-color: var(--dl-toolbar-action-color, inherit);
					--vaadin-button-border-color: var(--dl-toolbar-action-border, grey);
				}
				
				.main-toolbar-action {
					display: grid !important;
					padding: 10px;
					background-color: var(--dl-toolbar-action-background, whitesmoke);
					color: var(--dl-toolbar-action-color, inherit);
					border: 1px solid var(--dl-toolbar-action-border, grey);
					position: absolute;
					z-index: 9999;
					overflow: scroll;
					width: 92%;
					left: 2%;
					top: 0px;
				}
		
				.mask {
					display: none;
					position: absolute;
					top: 0px;
					left: 0px;
					right: 0px;
					bottom: 0px;
					z-index: 99;
					background-color: black;
					opacity: .3;
				}
				
				.mask-display {
					display: block;
				}				
				
				.spacer {
					margin-left: 5px;
					margin-right: 5px;
				}
				
				@media only screen and (max-width: 1024px) {
					.main-toolbar {
						display: none;
					}
					.action-button {
						display: block;
					}
					
				}
				
			</style>
			<vaadin-button class="action-button" @click="${this.toggleActionMenu}">${this.collapseLabel}</vaadin-button>
			<div class="mask" itemid="mask"></div>
			<div itemid="maincontent" class="main-toolbar" style="${this.bodyStyle}">
				<slot></slot>
			</div>			
		`;
	}
	
	init() {
		var toolbar = this;
		
		window.addEventListener('click', function(event){
			if (event.target.getAttribute('keep-open')) {
				return;
			}
			
			if (toolbar.hideAction) {
				var mask = ElementUtil.query(toolbar.shadowRoot, 'mask');
				var mainContent = ElementUtil.query(toolbar.shadowRoot, 'maincontent');
				if (!mask || !mainContent) {
					toolbar.hideAction = false;
					return;
				}
				mask.classList.remove('mask-display');
				mainContent.classList.remove('main-toolbar-action');
				toolbar.hideAction = false;
				
				var actionEvent = new CustomEvent('action-menu-close', { detail: '' });
				toolbar.dispatchEvent(actionEvent);
			}
		});
		
	}
	
	toggleActionMenu(event) {
		var toolbar = this;
		
		if (toolbar.hideAction) {
			var mask = ElementUtil.query(toolbar.shadowRoot, 'mask');
			var mainContent = ElementUtil.query(toolbar.shadowRoot, 'maincontent');
			if (mask && mainContent) {
				mainContent.classList.remove('main-toolbar-action');
				mask.classList.remove('mask-display');
			}
			toolbar.hideAction = false;
			
			var actionEvent = new CustomEvent('action-menu-close', { detail: '' });
			toolbar.dispatchEvent(actionEvent);
		} else {
			var openMask = ElementUtil.query(toolbar.shadowRoot, 'mask');
			var openMainContent = ElementUtil.query(toolbar.shadowRoot, 'maincontent');
			if (!openMask || !openMainContent) {
				return;
			}
			openMask.classList.add('mask-display');
			openMainContent.classList.add('main-toolbar-action');
			toolbar.hideAction = true;
			
			var actionEvent = new CustomEvent('action-menu-open', { detail: '' });
			toolbar.dispatchEvent(actionEvent);
		}
		event.stopPropagation();
		event.preventDefault();		
		
	}
	
};
customElements.define('dl-toolbar', Toolbar);

